import React from "react";
import { Route, Routes } from "react-router-dom";
import { DashboardPage } from "@/pages/Student/Dashboard/DashboardPage";
import { ProfilePage } from "@/pages/Profile/ProfilePage";
import { SettingsPage } from "@/pages/Settings/SettingsPage";
import { StudentExercisesPage } from "@/pages/Student/Exercises/StudentExercisesPage";
import { StudentPackagesPage } from "@/pages/Student/Packages/StudentPackagesPage";
import { PackageDetailsPage } from "@/pages/PackageDetails/PackageDetailsPage";
import { StudentModulesPage } from "@/pages/Student/Modules/StudentModulesPage";
import { VoucherPage } from "@/pages/Student/Voucher/VoucherPage";
import { KnowledgeCloudPage } from "@/pages/Student/KnowledgeCloud/KnowledgeCloudPage";
import { CartPage } from "@/pages/Student/Cart/CartPage";
import { CheckoutPage } from "@/pages/Student/Checkout/CheckoutPage";
import { CheckoutSuccessPage } from "@/pages/Student/Checkout/CheckoutSuccessPage";
import { StudentSubscriptionsPage } from "@/pages/Student/Subscriptions/StudentSubscriptionsPage";
import { LevelTestGate } from "@/components/student/LevelTest/LevelTestGate";
import { WelcomeTest } from "@/pages/Student/LevelTest/WelcomeTest";
import LevelingTest from "@/pages/Student/LevelTest/LevelingTest";
import { TestResult } from "@/pages/Student/LevelTest/TestResult";
import { ModuleTestPage } from "@/pages/Student/ModuleTest/ModuleTestPage";
import { ModuleTestResultPage } from "@/pages/Student/ModuleTest/ModuleTestResultPage";
import { ModuleCompletionPage } from "@/pages/Student/Modules/ModuleCompletionPage";
import PrivateRoute from "./PrivateRoute";
import { AuthRole } from "@/services/shared/auth/auth.interfaces";
import { LevelTestProgressProvider } from "@/contexts/LevelTestProgressContext";
import { ModuleExercisesProvider } from "@/contexts/ModuleExercisesContext";

const StudentRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute component={LevelTestGate} userRole={AuthRole.Student} />
        }
      />
      <Route
        path="dashboard"
        element={
          <PrivateRoute
            component={StudentModulesPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="profile"
        element={
          <PrivateRoute component={ProfilePage} userRole={AuthRole.Student} />
        }
      />
      <Route
        path="settings"
        element={
          <PrivateRoute component={SettingsPage} userRole={AuthRole.Student} />
        }
      />
      <Route
        path="exercises"
        element={
          <ModuleExercisesProvider>
            <PrivateRoute
              component={StudentExercisesPage}
              userRole={AuthRole.Student}
            />
          </ModuleExercisesProvider>
        }
      />
      <Route
        path="exercises/:moduleId"
        element={
          <ModuleExercisesProvider>
            <PrivateRoute
              component={StudentExercisesPage}
              userRole={AuthRole.Student}
            />
          </ModuleExercisesProvider>
        }
      />
      <Route
        path="voucher"
        element={
          <PrivateRoute component={VoucherPage} userRole={AuthRole.Student} />
        }
      />
      <Route
        path="packages"
        element={
          <PrivateRoute
            component={StudentPackagesPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="subscriptions"
        element={
          <PrivateRoute
            component={StudentSubscriptionsPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="packages/:packageId"
        element={
          <PrivateRoute
            component={PackageDetailsPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="modules"
        element={
          <PrivateRoute
            component={StudentModulesPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="modules/:packageId"
        element={
          <PrivateRoute
            component={StudentModulesPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="modules/:moduleId/completion"
        element={
          <PrivateRoute
            component={ModuleCompletionPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="modules/:moduleId/test"
        element={
          <PrivateRoute
            component={ModuleTestPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="modules/:moduleId/test/result"
        element={
          <PrivateRoute
            component={ModuleTestResultPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="knowledge-cloud"
        element={
          <PrivateRoute
            component={KnowledgeCloudPage}
            userRole={AuthRole.Student}
          />
        }
      />
      <Route
        path="cart"
        element={
          <PrivateRoute component={CartPage} userRole={AuthRole.Student} />
        }
      />
      <Route
        path="checkout/:packageId"
        element={
          <PrivateRoute component={CheckoutPage} userRole={AuthRole.Student} />
        }
      />
      <Route
        path="checkout/success"
        element={
          <PrivateRoute component={CheckoutSuccessPage} userRole={AuthRole.Student} />
        }
      />
      {/* Rotas de Level Test envolvidas com LevelTestProgressProvider para garantir
          que todos os hooks (useLevelTest, useLevelTestProgress) funcionem corretamente */}
      <Route
        path="level-test"
        element={
          <LevelTestProgressProvider>
            <PrivateRoute component={LevelTestGate} userRole={AuthRole.Student} />
          </LevelTestProgressProvider>
        }
      />
      <Route
        path="level-test/welcome"
        element={
          <LevelTestProgressProvider>
            <PrivateRoute component={WelcomeTest} userRole={AuthRole.Student} />
          </LevelTestProgressProvider>
        }
      />
      <Route
        path="level-test/test"
        element={
          <LevelTestProgressProvider>
            <PrivateRoute component={LevelingTest} userRole={AuthRole.Student} />
          </LevelTestProgressProvider>
        }
      />
      <Route
        path="level-test/result"
        element={
          <LevelTestProgressProvider>
            <PrivateRoute component={TestResult} userRole={AuthRole.Student} />
          </LevelTestProgressProvider>
        }
      />
      <Route
        path="*"
        element={
          <PrivateRoute component={LevelTestGate} userRole={AuthRole.Student} />
        }
      />
    </Routes>
  );
};

export default StudentRoutes;
